import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02449d5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-active modal" }
const _hoisted_2 = { class: "modal-card modal-card-size" }
const _hoisted_3 = { class: "box box-size" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "hoopsWebViewer" }, null, -1))

import { HoopsConfigs, useComposablesForVueComponentWithHoopsCommunicator } from '@/plugins/hoops'
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import BottomToolbar from '@/components/admin/content/editor/part/three-d/BottomToolbar.vue'
import TopToolbar from '@/components/admin/content/editor/part/three-d/TopToolbar.vue'
import TopToolbarMobile from '@/components/admin/content/editor/part/three-d/TopToolbarMobile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Part3dModal',
  props: {
  filepath: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {


const emit = __emit
const props = __props
const store = useStore()
const close = () => emit('close')

useComposablesForVueComponentWithHoopsCommunicator()

onMounted(async () => {
  await store.dispatch(
    'hoopsWebViewer/createViewer',
    new HoopsConfigs({
      elementId: 'hoopsWebViewer',
      filepath: props.filepath,
      snapshotFilename: props.title
    })
  )
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "delete is-hidden-touch is-pulled-right",
            "aria-label": "close",
            onClick: close
          }),
          _createVNode(TopToolbar, {
            class: "toolbar-size mb-1",
            title: __props.title
          }, null, 8, ["title"])
        ]),
        _createVNode(TopToolbarMobile, {
          class: "toolbar-size mb-1",
          "has-close-option": "",
          title: __props.title,
          onClose: close
        }, null, 8, ["title"]),
        _hoisted_5,
        _createVNode(BottomToolbar, { class: "toolbar-size mt-1" })
      ])
    ])
  ]))
}
}

})